export interface MemberDetailsDto
{
    getMemberName(): string;
    getMsisdn(): string;
}

export class MemberDetailsDtoImpl implements MemberDetailsDto
{
    private memberName: string;
    private msisdn: string;

    setMemberName(memberName: string)
    {
        this.memberName = memberName;
    }
    getMemberName(): string
    {
       return this.memberName;
    }    

    setMsisdn(msisdn: string)
    {
        this.msisdn = msisdn;
    }
    getMsisdn(): string 
    {
        return this.msisdn;
    }
}


// WEBPACK FOOTER //
// ./src/com/sixdee/crbtportal/core/dto/listtones/memberdetailsdto.ts